import script from "./PendingActionsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingActionsPanel.vue?vue&type=script&setup=true&lang=js"

import "./PendingActionsPanel.vue?vue&type=style&index=0&id=b68576fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b68576fa"]])

export default __exports__